<template>
  <div class="kalendar-event-types">
    <div class="open-folder-line">
      <div :class="['open-folder-line-left', tab_name == 'rocista' ? 'rocisnik-line' : '']">
        <div class="posta-dropdown" v-if="tab_name != 'rocista'">
          Prikaži:
          <select id="search-group multiple" v-model="select_event_type">
            <option v-for="(ev_type, key) in filter_event_type" :key="key" :value="ev_type.id">
              {{ ev_type.naziv }}
            </option>
          </select>
          <!-- <input type="submit" value="Submit" /> -->
          <img class="calendar-arrow" src="@/assets/img/strelica_dupla.svg" />
        </div>

        <v-menu ref="menu1" v-model="menu1" :close-on-content-click="false" transition="scale-transition" offset-y
          max-width="290px" min-width="auto" v-if="tab_name == 'rocista'">
          <template v-slot:activator="{ on, attrs }">
            <v-text-field v-model="dateRangeText" readonly clearable label="Odaberite period" v-bind="attrs"
              @click="menu1 = !menu1" v-on="on" class="case-date-picker rocista-date-picker"></v-text-field>
          </template>
          <v-date-picker locale="hr" v-model="date_range" range no-title :pickerDate.sync="pickerDate"></v-date-picker>
        </v-menu>
        <div v-if="tab_name == 'rocista'" class="rocisnik-info">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
            <path fill-rule="evenodd" clip-rule="evenodd"
              d="M0 9.99927C0 4.48027 4.48 -0.000732422 10 -0.000732422C15.53 -0.000732422 20 4.48027 20 9.99927C20 15.5203 15.53 19.9993 10 19.9993C4.48 19.9993 0 15.5203 0 9.99927ZM9.12 6.20927C9.12 5.73027 9.52 5.32927 10 5.32927C10.48 5.32927 10.87 5.73027 10.87 6.20927V10.6293C10.87 11.1103 10.48 11.4993 10 11.4993C9.52 11.4993 9.12 11.1103 9.12 10.6293V6.20927ZM10.01 14.6803C9.52 14.6803 9.13 14.2803 9.13 13.8003C9.13 13.3203 9.52 12.9303 10 12.9303C10.49 12.9303 10.88 13.3203 10.88 13.8003C10.88 14.2803 10.49 14.6803 10.01 14.6803Z"
              fill="#FD4087" />
          </svg>
          <span>{{ date_range.length > 0 ? 'Prikazuju se sva ročišta organizacije u odabranom periodu' : 'Prikazuju se sva nadolazeća ročišta organizacije'}}</span>
          <div class="vertical-divider"></div>
          <div class="generiraj-rocisnik-button" @click="generateReport">
            <svg xmlns="http://www.w3.org/2000/svg" width="21" height="22" viewBox="0 0 21 22" fill="none">
              <path d="M5.24463 13.7815L8.23776 9.89137L11.652 12.5733L14.581 8.79297" stroke="#2B2B41" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              <circle cx="17.9954" cy="3.20027" r="1.9222" stroke="#2B2B41" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M12.9243 2.12024H5.65655C2.64511 2.12024 0.777832 4.25296 0.777832 7.2644V15.3468C0.777832 18.3582 2.6085 20.4818 5.65655 20.4818H14.2607C17.2721 20.4818 19.1394 18.3582 19.1394 15.3468V8.30788" stroke="#2B2B41" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            <span>Generiraj izvještaj</span>
          </div>
        </div>
      </div>
      <div v-if="all_events.length != 0 && all_pages.length > 1" class="cases-pagination-left">
        <div class="pagin-wrapp page-nav">
          <div class="page-nav-prev" v-if="!isFirstPage" @click="setPage(curr_page - 1)">
            <svg id="SVGDoc" width="71" height="72" xmlns="http://www.w3.org/2000/svg" version="1.1"
              xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 71 72">
              <defs>
                <clipPath id="ClipPath1018">
                  <path
                    d="M35.43895,20.86385v0c-8.37994,0 -15.15353,6.7734 -15.15353,15.15328v0c0,8.37975 6.77359,15.15341 15.15353,15.15341v0c8.3797,0 15.15329,-6.77366 15.15329,-15.15341v0c0,-8.37988 -6.77359,-15.15328 -15.15329,-15.15328z"
                    fill="#ffffff"></path>
                </clipPath>
              </defs>
              <g>
                <g>
                  <g>
                    <path class="sssdf"
                      d="M35.43895,20.86385v0c-8.37994,0 -15.15353,6.7734 -15.15353,15.15328v0c0,8.37975 6.77359,15.15341 15.15353,15.15341v0c8.3797,0 15.15329,-6.77366 15.15329,-15.15341v0c0,-8.37988 -6.77359,-15.15328 -15.15329,-15.15328z"
                      fill-opacity="0" fill="#ffffff" stroke-dashoffset="0" stroke-dasharray="" stroke-linejoin="miter"
                      stroke-linecap="butt" stroke-opacity="1" stroke="#c2c2c2" stroke-miterlimit="20" stroke-width="2"
                      clip-path='url("#ClipPath1018")'></path>
                  </g>
                  <g>
                    <g>
                      <path class="sssdr" d="M37.11694,40.02775v0l-4.09639,-4.09664v0l4.09639,-4.09638v0"
                        fill-opacity="0" fill="#ffffff" stroke-dashoffset="0" stroke-dasharray=""
                        stroke-linejoin="miter" stroke-linecap="butt" stroke-opacity="1" stroke="#2b2b41"
                        stroke-miterlimit="20" stroke-width="2"></path>
                    </g>
                    <g>
                      <path d="M40.30245,40.02775v0l-4.09651,-4.09664v0l4.09651,-4.09638v0" fill-opacity="0"
                        fill="#ffffff" stroke-dashoffset="0" stroke-dasharray="" stroke-linejoin="miter"
                        stroke-linecap="butt" stroke-opacity="1" stroke="#f6eeff" stroke-miterlimit="20"
                        stroke-width="2"></path>
                    </g>
                  </g>
                </g>
              </g>
            </svg>
          </div>
          <div class="page-nav-no">
            <div :class="{ 'curr-page': curr_page == 1 }" @click="setPage(1)">
              1
            </div>
          </div>
          <div class="page-nav-no" v-if="left_dots_visible">
            <div>
              ...
            </div>
          </div>
          <div class="page-nav-no" v-for="(str, key) in getLeftRightPages" :key="key" @click="setPage(str)">
            <div :class="{ 'curr-page': curr_page == str }">
              {{ str }}
            </div>
          </div>
          <div class="page-nav-no" v-if="right_dots_visible">
            <div>
              ...
            </div>
          </div>
          <div class="page-nav-no" v-if="all_pages.length>1">
          <div :class="{ 'curr-page': curr_page == all_pages.length }"
            @click="setPage(all_pages.length)">
            {{ all_pages.length }}
          </div>
          </div>
          <div class="page-nav-next" v-if="!isLastPage" @click="setPage(curr_page + 1)">
            <svg id="SVGDoc" width="71" height="72" xmlns="http://www.w3.org/2000/svg" version="1.1"
              xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 71 72">
              <defs>
                <clipPath id="ClipPath1043">
                  <path
                    d="M35.53479,20.86385v0c8.36551,0 15.1273,6.7616 15.1273,15.12705v0c0,8.36519 -6.76179,15.12718 -15.1273,15.12718v0c-8.36515,0 -15.12682,-6.76199 -15.12682,-15.12718v0c0,-8.36545 6.76167,-15.12705 15.12682,-15.12705z"
                    fill="#ffffff"></path>
                </clipPath>
              </defs>
              <g>
                <g>
                  <g>
                    <path class="sssdf"
                      d="M35.53479,20.86385v0c8.36551,0 15.1273,6.7616 15.1273,15.12705v0c0,8.36519 -6.76179,15.12718 -15.1273,15.12718v0c-8.36515,0 -15.12682,-6.76199 -15.12682,-15.12718v0c0,-8.36545 6.76167,-15.12705 15.12682,-15.12705z"
                      fill-opacity="0" fill="#ffffff" stroke-dashoffset="0" stroke-dasharray="" stroke-linejoin="miter"
                      stroke-linecap="butt" stroke-opacity="1" stroke="#c2c2c2" stroke-miterlimit="20" stroke-width="2"
                      clip-path='url("#ClipPath1043")'></path>
                  </g>
                  <g>
                    <g>
                      >
                      <path class="sssdr" d="M33.88303,40.02775v0l4.09651,-4.09664v0l-4.09651,-4.09638v0"
                        fill-opacity="0" fill="#ffffff" stroke-dashoffset="0" stroke-dasharray=""
                        stroke-linejoin="miter" stroke-linecap="butt" stroke-opacity="1" stroke="#2b2b41"
                        stroke-miterlimit="20" stroke-width="2"></path>
                    </g>
                    <g>
                      <path d="M30.69751,40.02775v0l4.09663,-4.09664v0l-4.09663,-4.09638v0" fill-opacity="0"
                        fill="#ffffff" stroke-dashoffset="0" stroke-dasharray="" stroke-linejoin="miter"
                        stroke-linecap="butt" stroke-opacity="1" stroke="#f6eeff" stroke-miterlimit="20"
                        stroke-width="2"></path>
                    </g>
                  </g>
                </g>
              </g>
            </svg>
          </div>
        </div>
      </div>
    </div>

    <div v-if="fetching" class="paznja-spinner">
      <svg class="dot-spin" viewBox="0 0 50 50">
        <circle class="path" cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
      </svg>
    </div>
    <div v-if="all_events.length > 0" class="event-list-wrapper" :key="refreshKey">
      <EventCard v-for="(single_event, key) in finalni_arr_prikaza" :key="key" :single_event="single_event"
        :event_wrapper_class="'events-tab-view'" :tab_name="tab_name" />
    </div>
    <div v-if="!fetching && all_events.length == 0" class="event-list-wrapper">
      <div class="poruka-empty">
        Trenutno nema dostupnih događaja
      </div>
    </div>

  </div>
</template>

<script>
import EventCard from "@/components/calendarComponents/EventCard.vue";
import ms_calendar from "@/apiCallers/calendarSharepoint";
import person from "@/apiCallers/person";
import auth from "@/services/auth";
import moment from "moment";
import DataLoader from '@/components/generalComponents/DataLoader'
export default {
  props: ["tab_name"],
  components: {
    EventCard,
    DataLoader
  },
  data() {
    return {
      rasporedi_liste: [[], [], []],
      all_events: [],
      accessToken: "",
      filter_event_type: [{ naziv: "Svi događaji", id: 0 }],
      select_event_type: 0,
      fetching: true,
      refreshKey: 0,
      finalni_arr_prikaza: [],
      curr_page: 1,
      br_redova: 9,
      all_pages: [],
      menu1: false,
      date_range: [],
      pickerDate: null,
      first_open: true,
      left_dots_visible: false,
      right_dots_visible: false,
    };
  },
  watch: {
    select_event_type: function () {
      this.fetchData();
    },
    curr_page: function () {
      this.paginirajOdabrane();
    },
    date_range: function () {
        this.fetchData()
    },
    pickerDate: function () {
      let is_same_month = false;
      if(this.date_range.length == 2)
        is_same_month = (moment(this.date_range[0]).month() == moment(this.date_range[1]).month())
      else if(this.date_range.length == 0)
        is_same_month = true

      if (!this.first_open && is_same_month) {
        let listed_date = []
        listed_date.push(moment(this.pickerDate).startOf("month").format("YYYY-MM-DD"));
        listed_date.push(moment(this.pickerDate).endOf("month").format("YYYY-MM-DD"));
        this.date_range = listed_date
        // console.log(listed_date)
      } else
        this.first_open = false
    },
  },
  computed: {
    isFirstPage() {
      return this.curr_page == 1;
    },
    isLastPage() {
      return this.curr_page == this.all_pages[this.all_pages.length - 1];
    },
    getLeftRightPages() {
      // Init values
      let return_pages = []
      this.right_dots_visible = false;
      this.left_dots_visible = false;
      // Left of current page
      // 3 is the bottom value to make ... sense
      // LEFT LOOP
      let left_start = 2;
      let left_end = this.curr_page;
      if(this.curr_page == this.all_pages.length)
        left_end = this.curr_page-1;
      if (this.curr_page > 3) {
        left_start = this.curr_page - 1;
        this.left_dots_visible = true;
      }
      for (let j = left_start; j <= left_end; j++) {
        return_pages.push(j);
      }
      // RIGHT LOOP
      let right_start = this.curr_page + 1;
      if (right_start < this.all_pages.length)
        return_pages.push(right_start);
      if(right_start < this.all_pages.length-1)
      this.right_dots_visible = true;
      return return_pages
    },
    dateRangeText: {
      get() {
        var ret_date_string = [];
        this.date_range.forEach((p) => {
          ret_date_string.push(moment(p).format("l"));
        });
        return ret_date_string.join(" ~ ");
      },
      set(new_val) {
        // console.log(new_val)
        if (new_val == null) {
          this.date_range = [];
        }
      }
    },
  },
  methods: {
    generateReport(){
      this.$store.state.rocista_report_data.events = this.all_events;
      this.$store.state.rocista_report_data.razdoblje = this.dateRangeText;
      this.$router.push({ name: 'RocistaReport'});
      // let routeData = this.$router.resolve({name: 'RocistaReport',  query: {rocista: {...this.all_events}}});
      // window.open(routeData.href, '_blank');
    },
    logIt() {
      // console.log("Dalje")
    },
    calculatePageNumber() {
      this.all_pages = [];
      var finalni_broj = this.all_events.length / this.br_redova;
      if (this.all_events.length % this.br_redova >= 1) {
        finalni_broj++;
      }
      for (var i = 1; i <= finalni_broj; i++) {
        this.all_pages.push(i);
      }
      if (this.all_pages.length != 0) {
        this.curr_page = 1;
      }
      // console.log(finalni_broj);
    },
    paginirajOdabrane() {
      let start_idx = 0 + this.br_redova * (this.curr_page - 1);
      let end_idx = this.br_redova * this.curr_page;

      this.finalni_arr_prikaza = this.all_events.slice(start_idx, end_idx);
    },
    setPage(pg) {
      this.curr_page = pg;
    },
    async fetchData() {
      // TO DO dohvatiti prave podatke ovisno o tabu
      this.all_events = [];
      this.fetching = true;
      this.accessToken = await auth.acquireToken(process.env.GRAPH_SCOPES);
      let lawyer_id = await person.getSelf(this.accessToken);
      lawyer_id = lawyer_id.data.uid;
      (this.rasporedi_liste = [[], [], []]), (this.raspon_datuma = []);
      var start_date = null;
      var end_date = null;
      var temp_date = [...this.date_range].sort((a, b) => new Date(a) - new Date(b))
      if (temp_date.length > 0) {
        start_date = temp_date[0];
        if (temp_date.length > 1) {
          end_date = temp_date[1];
        }
      }



      await ms_calendar
        .getPersonCalendarList(
          this.accessToken,
          lawyer_id,
          this.select_event_type,
          this.tab_name,
          start_date,
          end_date
        )
        .then((resp) => {
          // console.log(resp.data);
          this.rasporedi_liste[2] = resp.data;
          this.fetching = false;
          this.all_events = this.rasporedi_liste[2];
          this.calculatePageNumber();
          this.paginirajOdabrane();
        });

    },
  },
  async created() {
    await this.fetchData();

    await ms_calendar.getEventType().then((resp) => {
      resp.data.map((ev) => this.filter_event_type.push({ naziv: ev.name, id: ev.uid }));
    });
    if (this.tab_name == 'rocista') {
      this.$store.state.rocista_tab_active = true;
    }
    else{
      this.$store.state.rocista_tab_active = false;
    }
  },
  mounted() {

  },
};
</script>